import HttpFactory from '@/mixins/http.factory';
import { mapState, mapActions, mapGetters } from 'vuex';
export default {
	name:'oauth_callback',
	mixins:[HttpFactory],
	data () {
		return {
			data:null,
			isFormValidated:false,
			disableValidateBtn:true,
			auth: {},
			data:null,
		}
    },
    computed:{
		...mapState('zdDevops',['appData'])
	},
	created(){
		this.init();
	},
	methods: {
		async init(){
			let _self = this;
			_self.loading = true;
			let data = {
				code: _self.$route.query.code,
				state:_self.$route.query.state,
            };
            _self.data = data;
			if (!data.state || !data.code) {
				alert('Authorization failed. Please try again later. If the issue persists please contact at support@devopsintegration.io');
            }
            
            // modalClient = ZAFClient.init();
			// parentClient=null;
            // modalClient.on('send_data_to_modal', async (data) => {
            //   	if (data.ticket.id == _self.$route.params.zdTicketId) {
			// 		parentClient = modalClient.instance(data.parentClientGuid)
            //         _self.zendeskInfo = data;
            //   		//_self.githubTenant = _self.zendeskInfo.userInfo.allowMultiTenant ? _self.zendeskInfo.userInfo.defaultTenant : null;
            //         
			// 	}
            // });
            const stateStr = data.state;
            let config = sessionStorage[`zd_app_Auth_usr_${stateStr}`] ? JSON.parse(sessionStorage[`zd_app_Auth_usr_${stateStr}`]) : null;
            _self.zendeskInfo = { credentials: config.credentials, user: config.user };
            
            _self.auth.githubUrl = config.githubUrl ? config.githubUrl: null;
			
			_self.auth.userId=data.state;
			_self.auth.hdLoginUrl = config.hdLoginUrl;
            _self.auth.code = data.code;
            
            // if (!config.userDetailId && config.githubUrl) {
            //     config.userDetailId = config.githubUrl ? parseInt(config.githubUrl.split('?userDetailId=')[1]) : null;
            //     config.userDetailId = isNaN(parseInt(config.userDetailId)) == true ? null : parseInt(config.userDetailId);
            // }
			
            //_self.auth.hdEmail=_self.zendeskInfo.user.email;
            
			//_self.loading = false;
            let githubAuthData = {
                auth: config.credentials,
                userId:config.userId,
                appId: config.appId,
                installationId: config.installationId,
                githubUrl: _self.auth.githubUrl,
                hdLoginUrl: _self.auth.hdLoginUrl,
                userEmail:config.hdEmail
            };
            
            //console.log('user level auth started', JSON.stringify(config));
            //console.log('auth data on outh2 callbnack', config);
            // if (config.userId > 0 && !config.userDetailId) {
            //     _self.userLevelAuthentication_OAuth2(_self.data,data.state);
            // }
            //_self.isGithubAuthNeededFn_Data(githubAuthData,_self.data,config,data.state);
            _self.fn().showLoader(false);
            
			//_self.getAccessTokenFromCodeFn();
        },
        isGithubAuthNeededFn_Data: function (githubAuthData,userLevelAuthData,config,state) {
            const _self = this;
            _self.fn().showLoader(true);
			_self.isGithubAuthNeededFn(githubAuthData, function (response) {
				_self.fn().showLoader(false);
                let userMsg;
                if (response.data.Success && response.data.isGithubAuthNeeded==false) {
                    //if (config.userId > 0 && !config.userDetailId) {
                        _self.userLevelAuthentication_OAuth2(userLevelAuthData, state);
                    //}
				}else{
                    //github level auth is needed
                    _self.fn().showLoader(false);
                }
                
			},function(error){ 
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
        //begins user level authentication via OAuth2
        async userLevelAuthentication_OAuth2(data,state){
			let _self = this;
			//_self.loading = true;
			if (!data.state || !data.code) {
				alert('Authorization failed. Please try again later. If the issue persists please contact at support@devopsintegration.io');
			}
            _self.getAccessTokenFromCodeFn(_self.auth,state);
		},
        getAccessTokenFromCodeFn: function (data,state) {
            const _self = this;
			_self.getAccessTokenFromCode(data, function (response) {
				_self.fn().showLoader(false);
				let userMsg;
				if(response.data.Success){
					userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Authorization done Successfully`]}
                    sessionStorage.removeItem(`zd_app_Auth_usr_${state}`);
				}else{
					userMsg={show:true,type:'danger',list:[response.data.Data?response.data.Data:`Authorization failed. Please try again later. If the issue persists please contact at support@devopsintegration.io`]}
				}
                _self.userMsg = userMsg;
                setTimeout(function () { _self.closeDialog(); }, 2000);
			},function(error){ 
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
		getAccessTokenFromCode:function(data,successCb,errorCb){
            var _self=this;
			
            var url = `zendesk/getAccessTokenFromCode`;
            _self.fn().clearMessage();
			_self.postServerFn(url,data,successCb,errorCb);
        },
        isGithubAuthNeeded:function(data,successCb,errorCb){
            var _self=this;
			
            var url = `zendesk/isGithubAuthNeeded`;
            _self.fn().clearMessage();
			_self.postServerFn(url,data,successCb,errorCb);
        },
        //ends user level authentication via OAuth2
		postServerFn(url,data,successCb,errorCb){
			let _self=this;
			data=data?data:{};
			data.auth=_self.zendeskInfo.credentials;
			_self.post(url,data).then(response=>{
				if(successCb) successCb(response);
			}).catch(error=>{
				if(errorCb) errorCb(error);
			});
		},
		//auth only
		checkForm: function (e,installBtnClick) {
            let _self=this;
            if(!installBtnClick){
                _self.disableValidateBtn=true;
                _self.isFormValidated=false;
            }
            
            _self.userMsg.list = [];
            _self.userMsg.type='danger';
            if (_self.auth.hdLoginUrl && _self.auth.hdToken
            && _self.auth.githubUrl && _self.auth.githubToken) {
                return true;
            }
            return;
            if (!_self.auth.hdLoginUrl) {
                _self.userMsg.list.push('zendesk Url is required.');
            } else if(!_self.validUrl(_self.auth.hdLoginUrl)){
                _self.userMsg.list.push('zendesk Url is invalid.');
            }
            if (!_self.auth.code) {
                _self.userMsg.list.push('zendesk Code is  required.');
            }
			if (!_self.auth.hdEmail) {
                _self.userMsg.list.push('zendesk Email is  required.');
            } else if(!_self.validEmail(_self.auth.hdEmail)){
				_self.userMsg.list.push('zendesk Email is  invalid.');
			}
            if (!_self.auth.githubUrl) {
                _self.userMsg.list.push('GitHub Url is  required.');
            }else if(!_self.validUrl(_self.auth.githubUrl)){
                _self.userMsg.list.push('GitHub Url is invalid.');
            }
            
            if (!_self.auth.githubToken) {
                _self.userMsg.list.push('GitHub Token is required.');
            }
            if(e){
                e.preventDefault();
            }
        },
        authenticate(e,cb){
            let _self=this;
            //if(!_self.checkForm(e)) return;
            _self.loading=true;
			_self.auth.appId=_self.zendeskInfo.credentials.appId;
			_self.auth.installationId=_self.zendeskInfo.credentials.installationId; 
            _self.auth.user = _self.zendeskInfo.user;
            _self.auth.userEmail = _self.zendeskInfo.user.email;
            _self.auth.isGithubAuthOnly = false;
            var options = {
                method: 'POST',
                body: _self.auth,
                json: true,
                //url: _self.baseUrl+'authenticate',
				url:'authenticate_outh2',
                headers: {'Content-Type': 'application/json'}
            }; 
            _self.userMsg.type='danger';
            _self.userMsg.list=[];
            _self.isFormValidated=false;
            _self.post(options.url,options.body).then(function(response) {
                _self.loading=false;
                if(cb) cb(null,response);
                if(response.data.Data && response.data.Success){
                    _self.userMsg.type='info';
                    _self.isFormValidated=true;
                    _self.userMsg.list.push('App validated successfully. Close this window to continue.');
                    //_self.init();
					_self.sendDataToParent(response.data);
                }else{
                    _self.userMsg.list.push('App validation failed.');
                    if(response && response.data && response.data.Errors && response.data.Errors.length>0){
                        for(var i=0;i<response.data.Errors.length;i++){
                            _self.userMsg.list.push(response.data.Errors[i].Message);
                        }
                    }
                }
            },function(error){
                _self.loading=false;
                _self.userMsg.list.push('App validation failed.');
                if(error && error.response && error.response.Errors && error.response.Errors.length>0){
                    for(var i=0;i<error.response.Errors.length;i++){
                        _self.userMsg.list.push(error.response.Errors[i].Message);
                    }
                }
                if(cb) cb(error);
            });
        },
		validateEmpty:function(txt) {
            if (!txt || txt.trim() === '') {
                return false;
            } else {
                return true;
            }
        },
        validUrl: function (value) {
            return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
        },
        validEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
		//auth ends
        closeDialog(data) {
            let _self= this;
			_self.fn().close_zendesk_modal(data);
		},
        sendDataToParent(data) {
            let _self = this;
            _self.closeDialog(data);
		},
	}
}

